import moment from "moment";

export const formateChange24Hour = (value) => {
  return moment(value, "hh:mm A").format("HH:mm:ss");
};
export const formateChange12Hour = (value) => {
  return moment(value, "HH:mm:ss").format("hh:mm A");
};
export const TodayDate = () => {
  return moment().format("YYYY-MM-DD");
};

// export const formatChangePoint = (value) => {
//   return value.replace(/[:\/\\-]/g, ".");
// };

export const formatChangeLetters = (value) => {
  return moment(value, "YYYY/MM/DD").format("ddd, MMM D");
};
export const formatChangeDate = (value) => {
  return moment(value).format("DD-MMM-YYYY, h:mm A");
};
export const formatChangeDateSlash = (value) => {
  return moment(value, "YYYY/MM/DD").format("YYYY-MM-DD");
};
export const formatChangeDays = (value) => {
  return moment(value).fromNow();
};
export const formatChangeDateUTC = (date) => {
  return moment(date).utc().format("YYYY-MM-DD HH:mm:ss");
};
// export const formatChangeNumber = (value) => {
//   return value.replace(/[a-zA-Z!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?`~ -]/g, "");
// };
export const formattedTime = (timestamp) => {
  if (!timestamp) return "";

  const now = moment();
  const isToday = moment(timestamp).isSame(now, "day");
  const isYesterday = moment(timestamp).isSame(
    moment().subtract(1, "days"),
    "day"
  );

  const formattedTime = isToday
    ? `${moment(timestamp).format("h:mm A")}, Today`
    : isYesterday
    ? `${moment(timestamp).format("h:mm A")}, Yesterday`
    : moment(timestamp).format("h:mm A, MMM D, YY");

  return formattedTime;
};
export function calculateDaysRemaining(expiryDate) {
  const now = new Date();
  const expiry = new Date(expiryDate);

  // Calculate the difference in milliseconds and convert to days
  const diffInMilliseconds = expiry - now;
  const daysRemaining = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));

  // Ensure it doesn't go below 0
  return Math.max(daysRemaining, 0);
}
